import { Foldable } from '@effect/typeclass/data/Array'
import { combineMap } from '@effect/typeclass/Foldable'

export const combineArray = combineMap(Foldable)
